module.exports = __webpack_public_path__ + "img/VA.22c9e56c.png";